import React, { Dispatch, useEffect, useState } from "react"
import { Button, Col, Input, message, Modal, Row, Select } from "antd"
import "./editModal.css"
import { createAndClose, getOlpnList } from "../../api/OLPN/olpn"
import { useParams } from "react-router-dom"
import moment from "moment"
import { updateTrayData } from "../../api/trayTable/TrayTableMethods"

interface DataType {
  _id: string,
  key: number,
  trayNumber: string,
  dateCreated: string,
  quantity: string,
  skuList: any[],
  photoId: string,
  OLPN: {
    OLPN: string,
    _id: string
  }
}

const { Option } = Select

const EditModal = (props: { setModalEdit: Dispatch<boolean>, editModal: boolean, data: DataType | undefined, makeCall: any }) => {
  const { setModalEdit, editModal, data } = props
  const { bpId } = useParams()
  const [isSelect, setIsSelect] = useState<boolean>(false)
  const [isCreateOlpn, setIsCreateOlpn] = useState<boolean>(false)
  const [newOlpn, setNewOlpn] = useState<string>("")
  const [olpn, setOlpn] = useState<string | undefined>(data?.OLPN?.OLPN)
  const [selectedOlpn, setSelectedOlpn] = useState<any>(data?.OLPN)
  const [value, setValue] = useState<string>("")
  const [olpnId, setOlpnId] = useState<string | undefined>(undefined)
  const [count, setCount] = useState<string | undefined>(data?.skuList.length as string | undefined)
  const [trayId, setTrayId] = useState<string | undefined>(data?.trayNumber)
  const [olpnList, setOlpnList] = useState<any>(undefined)

  useEffect(() => {
    getOlpn()
  }, [])

  useEffect(() => {
    if (data) {
      setSelectedOlpn(data.OLPN)
      setOlpn(data?.OLPN?.OLPN)
      setTrayId(data?.trayNumber)
      setCount(data.skuList.length)
    }
  }, [data])

  const getOlpn = async () => {
    const res = await getOlpnList(Number(bpId), true)
    if (res.status === 200)
      setOlpnList(res.data)
  }

  const handleCreateOlpn = () => {
    setIsCreateOlpn(!isCreateOlpn)
  }

  const handleSelectOlpn = () => {
    setIsSelect(!isSelect)
  }

  const addOlpn = async () => {
    const res = await createAndClose(Number(bpId), newOlpn)
    if (res) {
      setSelectedOlpn(res.data)
      setOlpnId(res.data._id)
      getOlpn()
      setIsCreateOlpn(false)
    }
  }

  const updateTray = async () => {
    var skuList = data?.skuList;
    if (data?.skuList && Number(count) !== data?.skuList?.length) {
      let diff = Number(count) - data?.skuList?.length
      console.log(diff)
      if (diff > 0)
        skuList?.push(...new Array(diff).fill({}))
      else
        skuList = skuList?.slice(diff * -1)
    }
    let obj = {
      trayId: trayId,
      olpnId: selectedOlpn._id,
      olpnName: olpn,
      skuList: skuList
    }
    if (bpId && data) {
      let res = await updateTrayData(data._id, obj)
      if (res.status === 200) {
        message.success("Plateau mis à jour")
        props.makeCall()
        setModalEdit(false)
      }
      else
        message.error("Une erreure c'est produite lors de la mise à jour du plateau")
    }
  }

  const CreateOlpn = () => (
    <Row>
      <Col xs={6}>
        <span className="olpn-title">Nouvel OLPN</span>
      </Col>
      <Col xs={12}><Input key={"newOlpn"} value={newOlpn} size="middle" onChange={(e) => setNewOlpn(e.target.value)} /></Col>
      <Col xs={4} push={1}><Button onClick={() => addOlpn()}>Ajouter</Button></Col>
      <Col xs={24} className="edit-col-modal edit-button-center">
        <Button onClick={() => setIsCreateOlpn(false)}>Retour</Button>
      </Col>
    </Row>
  )

  const SelectOlpn = () => (
    <Row >
      <Col xs={24}>
        <Select onChange={(e) => {
          const find = olpnList.find(el => el._id === e)
          const val = find.OLPN.length > 0 ? find.OLPN : `En cours ${moment(new Date(find.modifiedAt)).format('Do MMMM YYYY HH:mm:ss')}`
          setValue(val)
          setOlpnId(e)
          setOlpn(find.OLPN)
        }}
          value={value}
          style={{ width: '100%' }}>
          {olpnList.map((elem, index) => (
            <Option key={elem._id} >{elem.OLPN.length > 0 ? elem.OLPN : `En cours ${moment(new Date(elem.modifiedAt)).format('Do MMMM YYYY HH:mm:ss')}`}</Option>
          ))
          }
        </Select>
      </Col>
      <Col xs={12} style={{ paddingTop: "1rem", textAlign: "center" }}>
        <Button onClick={() => setIsSelect(false)}>Retour</Button>
      </Col>
      <Col xs={12} style={{ paddingTop: "1rem", textAlign: "center" }}>
        <Button onClick={() => {
          const find = olpnList.find((elem) => elem._id === olpnId)
          setSelectedOlpn(find)
          setIsSelect(false)
        }
        }>Valider</Button>
      </Col>
    </Row>
  )

  return (
    <Modal
      destroyOnClose
      open={editModal}
      onCancel={() => setModalEdit(false)}
      title={`Modification du plateau ${data?.trayNumber}`}
      footer={!isCreateOlpn && !isSelect && [
        <Button onClick={() => props.setModalEdit(false)} key="cancel">Annuler</Button>,
        <Button onClick={updateTray} style={{ backgroundColor: "#10b981", color: "white" }} key="ok" >Valider</Button>
      ]}
    >
      {isCreateOlpn && CreateOlpn()}
      {isSelect && <SelectOlpn />}
      {!isSelect && !isCreateOlpn &&
        <Row>
          <Col className="edit-col-modal" xs={24} md={4}>
            <div>OLPN</div>
          </Col>
          <Col xs={20} className="edit-col-modal">
            <Input
              disabled={selectedOlpn?.OLPN ? false : true}
              value={olpn}
              placeholder={selectedOlpn?.OLPN?.length ? selectedOlpn?.OLPN : `En cours ${moment(new Date(selectedOlpn?.modifiedAt)).format('Do MMMM YYYY HH:mm:ss')}`}
              onChange={(e) => setOlpn(e.target.value)}
              defaultValue={selectedOlpn?.OLPN.length ? selectedOlpn?.OLPN : ""}
              allowClear
            />
          </Col>
          <Col xs={24} md={24} className="edit-col-modal edit-button-center">
            <Button onClick={handleCreateOlpn}>Crée un OLPN</Button>
            <Button onClick={handleSelectOlpn} className="edit-olpn-button">Selectionner un OLPN</Button>
          </Col>
          <Col xs={4} className="edit-col-modal">
            <span>ID Plateau</span>
          </Col>
          <Col xs={20} className="edit-col-modal">
            <Input onChange={(e) => setTrayId(e.target.value)} value={trayId} placeholder={data?.trayNumber} defaultValue={data?.trayNumber} />
          </Col>
          <Col xs={4} className="edit-col-modal">
            <span>Quantité</span>
          </Col>
          <Col xs={20} className="edit-col-modal">
            <Input onChange={(e) => setCount(e.target.value)} type="number" value={count} placeholder={data?.skuList.length as string | undefined} defaultValue={data?.skuList.length} />
          </Col>
        </Row>
      }
    </Modal >
  )
}

export default EditModal;